import React from "react";
import Body from "../layouts/Body";
import { Box, Typography } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Body>
      <Typography
        variant="h5"
        className="page-title text-centered"
        color="primary"
      >
        Privacy & Cookie Policy
      </Typography>
      <Box sx={{ my: 2 }}>
        Respecting Your Privacy Our respect for our employees' right to security
        of their personal information is paramount. We have adopted this privacy
        policy ("Policy") which provides you with information about the kind of
        personal information which we may collect from you, how we handle such
        information and the rights which you have to control our use of your
        personal data. Your personal data collected by us shall be used by us
        strictly in accordance with applicable Indian Laws. This Policy sets out
        Our practices and policies on the management of personal information of
        our employees collected by us. Type of personal or sensitive personal
        data or information collected. The purpose of collection of personal
        information, the manner of collection, storage, use of and disclosure of
        such personal information; and Security practices and procedures adopted
        by us to protect your personal information collected by us. We request
        you to read this Policy carefully before sharing personal information
        with us. By visiting Tatastrive.com, we assume your acceptance to the
        practices described in this Policy and if you have any questions please
        contact us at STRIVE@tatasustainability.com What personal information do
        we collect and store We shall collect your personal information if it is
        reasonable and necessary to do so, subject to this Policy and applicable
        Indian law. We collect information in the following ways Information you
        give us. For example, when you upload any information about yourself
        like your name, email address, house/office address and telephone number
        in order to apply for job vacancies in Tata STRIVE. You also provide
        certain information when you create or update your profile on
        Tatastrive.com. Some of this information is visible to other
        Tatastrive.com subscribers. Information we get from your use of
        Tatastrive.com. This information includes, passwords, device
        information, location information, Cookies and anonymous identifiers.
        Information from Other Sources: We may also collect personal information
        about you from other third parties, such as third party service
        providers, whose websites you access through Tatastrive.com and with
        whom you share any information. We may also gather certain information
        automatically and store it in log files. For example, this information
        may include Internet Protocol (IP) addresses or other device
        identifiers, browser information, cookies Internet Service Provider
        (ISP), operating system, location, date/time stamp and clickstream data.
        We take reasonable measures to ensure that your personal information is
        protected from unauthorised access, loss, misuse, disclosure or
        alteration. Access to your personal information If you need to update
        your personal information in our records (e.g. if you change your
        address), please provide the updated details at the relevant place as
        stated above, to enable us to make the change. You may be requested to
        provide some verification before the information is recorded. We shall
        not be responsible for the authenticity of any personal information
        supplied to us by you. How we share your information You may be
        accessing several external links while navigating through
        Tatastrive.com. These external links may belong to Tata companies or
        third party service providers. We may share personal information with
        other Tata companies, and also with other third parties. Subject to the
        following terms Employee consent: We will share your personal
        information with other Tata companies, and also with other third parties
        only with your consent. You can indicate your consent by using the
        website and any services through the website. Same level of data
        protection: We shall share your personal information only with such
        companies, organisations and individuals that ensure the same level of
        data protection that is set out under this policy and as required by
        applicable Indian laws. Subject to the terms mentioned above, we would
        share your personal information with a third party for following reasons
        and under the following circumstances For external processing: Provide
        your personal information to our affiliates or other trusted business
        associates or technology partners to process it for us, based on our
        instructions and in compliance with this Policy and applicable laws.
        Third-Party Service Providers: We employ other companies and individuals
        to perform certain functions on our behalf. They have access to your
        personal information needed to perform their functions, but shall not
        use it for other purposes or disclose it further. Promotional Offers and
        contests: Sometimes we post offers and host Contests on Tatastrive.com
        on behalf of different Tata companies. We may share some of your details
        with the company to enable fulfilment of the offer or contest. For legal
        reasons: We will share your personal information if the same is
        necessary to: meet any applicable law, regulation, legal process or
        enforceable governmental request, enforce applicable Terms of Service,
        including investigation of potential violations, detect, prevent, or
        otherwise address fraud, security or technical issues, protect against
        harm to the rights, property or safety of us, our users or the public as
        required or permitted by law. Please note that we can share your
        personal information, without your consent, with Government agencies
        upon receiving a written request from any Government agency for such
        information. Information security We strive to protect ourselves and our
        users from unauthorised access to or unauthorised alteration, disclosure
        or destruction of information we hold. Grievance Cell If you have any
        concerns regarding: Discrepancies between the personal information
        provided by you and the information reflected in our records and the
        same have not been corrected and/or updated after you have provided
        updated information along with any verification required; or in respect
        of processing of your personal information; then you may contact
        STRIVE@tatasustainability.com Your concern shall be addressed in a
        time-bound manner. Use of Cookies The site may use cookies or web
        beacons to store personal information, only for the purpose of updating
        user preferences and to ensure fast loading of pages. Also hit counters
        and metres maybe used for statistical information and web reports.
        Changes Our Policy may change from time to time. We will not reduce your
        rights under this Policy without your explicit consent. We will post any
        changes or update to this Policy on this webpage and, if the changes are
        significant, we will provide a more prominent notice. We will also keep
        prior versions of this Policy in an archive for your review. When this
        Policy applies The Policy applies to all of the services offered by
        Tatastrive.com. This Policy does not apply to services offered by other
        companies or individuals, or other sites linked from Tatastrive.com, and
        which have separate privacy policies that do not incorporate this
        Policy. For example, the external websites which you may access through
        Tatastrive.com and which have their own privacy policies.
      </Box>
    </Body>
  );
};

export default PrivacyPolicy;
